import { useLocation } from 'react-router'
import { Paths } from 'src/constants/paths'
import { useHandleCheckLoginPasswordExpired } from 'src/features/auth/hooks/useHandleCheckLoginPasswordExpired'
import { useAgreement } from 'src/legacy_modules/auth/agreement/hooks/use-agreement'

export const usePostLoginNavigation = () => {
  const location = useLocation()
  const { handleAgreementCheck } = useAgreement()
  const { handleCheckLoginPasswordExpired } =
    useHandleCheckLoginPasswordExpired()

  const navigateToDashboard = () => {
    if (!!location.state?.from) {
      window.location.href = location.state.from
      return
    }
    // reloadを伴う遷移にして強制的にstateをリセットする
    window.location.href = Paths.Dashboard
  }

  const jumpAfterLogin = async () => {
    if (await handleAgreementCheck()) return
    if (await handleCheckLoginPasswordExpired()) return

    navigateToDashboard()
  }

  return {
    jumpAfterLogin,
    navigateToDashboard,
  }
}
